// extracted by mini-css-extract-plugin
module.exports = {"item":"menu-item_item___91Zf","itemLink":"menu-item_itemLink__wuXe1","itemLink--active":"menu-item_itemLink--active__QI4oD","itemIcon":"menu-item_itemIcon__o2tjC"};